
import { computed, defineComponent } from 'vue';
import postsStore from '@/store/posts';

import Post from '@/components/Post.vue';

export default defineComponent({
    name: 'Posts',

    components: { Post },

    setup() {
        const { posts, fetchPosts } = postsStore();

        fetchPosts();

        return { posts: computed(() => posts.value) };
    },
});
